export default "__VITE_ASSET__BmlRZUpk__"